/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  DeleteV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
  PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdBody,
  GetV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
  PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
} from '../types';

export class URLPrototypeReportMetricConfig extends Controller {
  async getV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeId<
    T extends GetV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      projectId,
      prototypeId,
    }: GetV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/url-prototypes/${prototypeId}/report-config`,
      axiosConfig
    );
  }

  async putV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeId<
    T extends PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdResponse,
    D,
    C extends PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PutV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/url-prototypes/${prototypeId}/report-config`,
      body,
      axiosConfig
    );
  }

  async deleteV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeId<
    T,
    D,
    C extends null
  >(
    {
      projectId,
      prototypeId,
    }: DeleteV2ProjectsUrlPrototypesReportConfigByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/projects/${projectId}/url-prototypes/${prototypeId}/report-config`,
      { ...axiosConfig, data: body }
    );
  }
}
